<header class="baer-header">
  <h1 id="support" class="site-page-title"><span class="large-font">Support</span></h1>
</header>
<main id="main-content" class="main-content">
  <section class="padding-y-2 padding-x-1">
    <div class="grid-container padding-x-1">
      <h2 class="usa-heading font-sans-lg margin-top-2 margin-bottom-2">Process List</h2>
      <div class="usa-divider width-full margin-y-2"></div>
      <div class="grid-row grid-gap-lg flex-align-start" style="margin-bottom: 20px;">
        <div class="grid-col-6 desktop:grid-col-3">
          <b>TL</b> - Team Leader
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>UBC</b> - Unit BAER Coordinator
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>RBC</b> - Regional BAER Coordinator
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>FLO</b> - Forest Line Officer
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>RLO</b> - Regional Line Officer
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>WLO</b> - Washington Office Line Officer
        </div>
        <div class="grid-col-6 desktop:grid-col-3">
          <b>WOL</b> - Washington Office Logistics
        </div>
      </div>
      <div class="grid-row grid-gap-lg flex-align-start">
        <div class="grid-col-12 desktop:grid-col-6">
          <h3>Fire Import and Report Creation Process</h3>
          <ul style="list-style-type: none;">
            <li>
              <h4><b>FIRE TRACKER</b></h4>
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>Fire Tracker</b> loads in new fires from GIS</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>UBC</b> can create new fires if needed (missing or &lt; 500 acres)</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>UBC</b> can merge fires - on multiple forest or complex fires</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>UBC</b> marks fire assessment as needed and complexity</span>
                </mat-list-item>
              </mat-list>
            </li>
            <li>
              <h4><b>ASSESSMENT TAB</b></h4>
              <mat-list>
                <mat-list-item style="height: 90px !important; margin-top: -15px;">
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>UBC</b> identifies TL on BAER Assessments tab</span>
                  <span matListItemLine>
                    <ul style="margin-top: -15px;">
                      <li><b>RBC</b> add TL when off forest</li>
                      <li><b>WOL</b> add team lead when out of region</li>
                    </ul>
                  </span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>STATUS:</b>
                    <mat-chip class="chip-3">{{3 | statusBadge}}</mat-chip>
                  </span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>TL</b> creates Initial Report from BAER Assessments tab or Fire
                    Overview</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>TL</b> adds team members</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>RBC</b> adds off unit Team members</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>WOL</b> adds team members out of region</span>
                </mat-list-item>
              </mat-list>
            </li>
            <li>
              <h4><b>REPORT</b></h4>
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>TL</b> completes 2500-8 Report</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>done</mat-icon>
                  <span matListItemTitle><b>see Report Completion, Sign and Certify Process</b></span>
                </mat-list-item>
              </mat-list>
            </li>
          </ul>
        </div>
        <div class="grid-col-12 desktop:grid-col-6">
          <h3>Report Completion, Sign and Certify Process</h3>
          <mat-list>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>REPORT STATUS:</b>
                <mat-chip class="chip-r-0">{{0 | reportStatusBadge}}</mat-chip>
              </span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle>starting with <b>TL</b> finishing report</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>TL</b> "Send for Review" to RBC for review</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>REPORT STATUS:</b>
                <mat-chip class="chip-r-3">{{3 | reportStatusBadge}}</mat-chip>
              </span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>RBC</b> add comments which will locked down submission.</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>RBC</b> works with TL to resolve</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>RBC</b> then "Request Final Report"</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>REPORT STATUS:</b>
                <mat-chip class="chip-r-1">{{1 | reportStatusBadge}}</mat-chip>
              </span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>TL</b> then "Send Final Report" - unresolved comments will block this
                step</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>REPORT STATUS:</b>
                <mat-chip class="chip-r-2">{{2 | reportStatusBadge}}</mat-chip>
                /
                <mat-chip class="chip-a-0">{{0 | authorizationStatusBadge}}</mat-chip>
              </span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>FLO</b> then reviews and hits "Sign & Certify Report"</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>RBC</b> and/or <b>WBC</b> treatment authorizations "Submit for Certification &
                Approval"</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>done</mat-icon>
              <span matListItemTitle><b>RLO</b> and/or <b>WLO</b> reviews and hits "Sign & Certify Report"</span>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </div>
  </section>


  <section class="padding-y-2 padding-x-1">
    <div class="grid-container padding-x-1">
      <h2 class="usa-heading font-sans-lg margin-top-2 margin-bottom-2">User Guides</h2>
      <div class="usa-divider width-full margin-y-2"></div>
      <ul class="usa-list usa-list--unstyled">
        @for (pair of guidePairs; track pair.right) {
        <li class="margin-0">
          <div class="grid-row grid-gap-lg flex-align-start">
            <div class="grid-col-12 desktop:grid-col-6">
              <div class="guide-cell border-bottom-1px border-base-lighter padding-y-2">
                <div class="grid-row grid-gap-2 flex-align-center">
                  <div class="grid-col-auto">
                    <fa-icon [icon]="faFileWord"
                      class="text-blue-50 fa-lg file-badge display-inline-block text-middle"></fa-icon>
                  </div>
                  <div class="grid-col fill">
                    <div class="file-title text-bold">{{ pair.left.title }}</div>
                  </div>
                  <div class="grid-col-auto">
                    <a class="usa-link display-inline-flex flex-align-center" [href]="pair.left.href" target="_blank"
                      rel="noopener" aria-label="Open {{ pair.left.title }} (opens in a new tab)">
                      <fa-icon [icon]="faArrowUpRightFromSquare" class="fa-regular fa-green"
                        aria-label="close"></fa-icon>
                      &nbsp;Open
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-col-12 desktop:grid-col-6">
              @if (pair.right) {
              <div class="guide-cell border-bottom-1px border-base-lighter padding-y-2">
                <div class="grid-row grid-gap-2 flex-align-center">
                  <div class="grid-col-auto">
                    <fa-icon [icon]="faFileWord"
                      class="text-blue-50 fa-lg file-badge display-inline-block text-middle"></fa-icon>
                  </div>
                  <div class="grid-col fill">
                    <div class="file-title text-bold">{{ pair.right.title }}</div>
                  </div>
                  <div class="grid-col-auto">
                    <a class="usa-link display-inline-flex flex-align-center" [href]="pair.right.href" target="_blank"
                      rel="noopener" aria-label="Open {{ pair.right.title }} (opens in a new tab)">
                      <fa-icon [icon]="faArrowUpRightFromSquare" class="fa-regular fa-green"
                        aria-label="close"></fa-icon>
                      &nbsp;Open
                    </a>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
  </section>
  <section class="padding-y-2 padding-x-1">
    <div class="grid-container padding-x-1">
      <h2 class="usa-heading font-sans-lg margin-top-2 margin-bottom-2">System Walkthrough Videos<span
          style="font-size: 14px; margin-left: 20px; color: #757575;">If videos appear broken, please <a target="_blank"
            href="https://usdagcc.sharepoint.com/">login to the sharepoint</a> site then reload this page</span></h2>
      <div class="usa-divider width-full margin-y-2"></div>
      <div class="width-full" style="display: flex; flex-wrap: wrap; gap: 20px;">
        <div style="flex: 0 0 calc(33.333% - 20px);">
          <h3>BAER Overview - Team Member</h3>
          <div style="max-width: 640px">
            <div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;"><iframe
                src="https://usdagcc.sharepoint.com/sites/fs-baer/_layouts/15/embed.aspx?UniqueId=df3e3933-88e3-4209-a462-04d4ba8f8f8a&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create"
                width="640" height="360" allowfullscreen title="BAEROverview_TeamMember.mp4"
                style="border:none; position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%; max-width: 100%; overflow: hidden"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>